import { render, staticRenderFns } from "./TermsAndCondsReferralProgram.vue?vue&type=template&id=f3b1ba9a&scoped=true&"
import script from "./TermsAndCondsReferralProgram.vue?vue&type=script&lang=js&"
export * from "./TermsAndCondsReferralProgram.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndCondsReferralProgram.vue?vue&type=style&index=0&id=f3b1ba9a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b1ba9a",
  null
  
)

export default component.exports